import { TRAVEL_TYPE_HOLIDAY_HOMES, TRAVEL_TYPE_OWN_ARRIVAL, TRAVEL_TYPE_PACKAGE_TOUR } from '../../../../../components/models.js';
export const PACKAGE_TOUR_WITH_FIELD = `${TRAVEL_TYPE_PACKAGE_TOUR}-withTravelTypeField`;
export const PACKAGE_TOUR_WITHOUT_FIELD = `${TRAVEL_TYPE_PACKAGE_TOUR}-withoutTravelTypeField`;
export const OWN_ARRIVAL_WITH_FIELD = `${TRAVEL_TYPE_OWN_ARRIVAL}-withTravelTypeField`;
export const OWN_ARRIVAL_WITHOUT_FIELD = `${TRAVEL_TYPE_OWN_ARRIVAL}-withoutTravelTypeField`;
export const HOLIDAY_HOMES_WITH_FIELD = `${TRAVEL_TYPE_HOLIDAY_HOMES}-withTravelTypeField`;
export const HOLIDAY_HOMES_WITHOUT_FIELD = `${TRAVEL_TYPE_HOLIDAY_HOMES}-withoutTravelTypeField`;
export const GRID_TEMPLATES = {
  [PACKAGE_TOUR_WITH_FIELD]: 'minmax(128px, 15%) auto minmax(194px, 20%) minmax(188px, 20%) minmax(100px, 15%)',
  [PACKAGE_TOUR_WITHOUT_FIELD]: 'auto minmax(150px, 20%) minmax(235px, 20%) minmax(181px, 15%)',
  [OWN_ARRIVAL_WITH_FIELD]: '200px auto minmax(255px, 20%) minmax(220px, 20%)',
  [OWN_ARRIVAL_WITHOUT_FIELD]: 'auto minmax(255px, 20%) minmax(220px, 20%)',
  [HOLIDAY_HOMES_WITH_FIELD]: '200px auto minmax(255px, 20%) minmax(220px, 20%)',
  [HOLIDAY_HOMES_WITHOUT_FIELD]: 'auto minmax(255px, 20%) minmax(220px, 20%)'
};